"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./PageHeader.scss");
var PageHeader = function (_a) {
    var dusk = _a.dusk, title = _a.title, breadcrumbs = _a.breadcrumbs, children = _a.children;
    return (react_1.default.createElement("div", { "data-dusk": dusk, className: "page-header" },
        react_1.default.createElement("div", null,
            react_1.default.createElement("h1", { className: "page-header__title" }, title),
            breadcrumbs.length > 0 && (react_1.default.createElement("div", { className: "page-header__crumbs" }, breadcrumbs.map(function (_a) {
                var label = _a.label;
                return label;
            })))),
        react_1.default.createElement("div", null, children)));
};
exports.default = PageHeader;
//# sourceMappingURL=index.js.map